import React from 'react';
import { Image, Modal, Pressable, StyleSheet, Text, View } from 'react-native';
import Ionicons from '@expo/vector-icons/Ionicons';
import { useSafeAreaInsets } from 'react-native-safe-area-context';
import { closeChatImageViewer, useChatImageViewerRequest } from './chatImageViewerStore';

/**
 * CORE-1741 — картинка из чата закрытой комнаты или Live во весь экран
 * (приложение). Файл уже в кеше: в браузер его не отдать — сервер отдаёт его
 * только с заголовками (`chatAttachmentFile.native.ts`).
 */
export const ChatImageViewerHost: React.FC = () => {
  const req = useChatImageViewerRequest();
  const insets = useSafeAreaInsets();
  if (!req) return null;
  return (
    <Modal visible transparent animationType="fade" onRequestClose={closeChatImageViewer}>
      <View style={s.backdrop} testID="chat-image-viewer">
        <Image source={{ uri: req.uri }} style={s.image} resizeMode="contain" accessibilityLabel={req.name ?? undefined} />
        <View style={[s.bar, { paddingTop: insets.top + 8 }]}>
          {!!req.name && <Text style={s.name} numberOfLines={1}>{req.name}</Text>}
          <Pressable
            onPress={closeChatImageViewer}
            accessibilityRole="button"
            accessibilityLabel="Закрыть"
            hitSlop={12}
            style={s.close}
            testID="chat-image-viewer-close"
          >
            <Ionicons name="close" size={28} color="#FFFFFF" />
          </Pressable>
        </View>
      </View>
    </Modal>
  );
};

const s = StyleSheet.create({
  backdrop: { flex: 1, backgroundColor: '#000000' },
  image: { ...StyleSheet.absoluteFillObject },
  bar: {
    position: 'absolute', left: 0, right: 0, top: 0,
    flexDirection: 'row', alignItems: 'center', gap: 12,
    paddingHorizontal: 16, paddingBottom: 8, backgroundColor: 'rgba(0,0,0,0.45)',
  },
  name: { flex: 1, color: '#FFFFFF', fontSize: 15 },
  close: { marginLeft: 'auto' },
});
